// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1adMB","col":"styles_col__oatOo","actions":"styles_actions__1r16j","conflict":"styles_conflict__2Sj8k"};